import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Page from './Page';
import LoginForm from './LoginForm';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { username, password } = values;
    this.props.login(username, password);
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Navigate to='/' />;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Login - Smart Gaming</title>
        </Helmet>
        <Page>
          <LoginForm onSubmit={this.onSubmit} />
        </Page>
      </React.Fragment>
    );
  }
}

export default LoginPage;